import React from "react";
import { useFetchVendorCategories } from "../../../VendorsView/VendorsTabsSections/Offers/hooks/fetchVendorCategories";
import { useState, useEffect } from "react";
import { GetAllVendorServices } from "../../../../../Services";
import { showError } from "../../../../../Helper";
import { useTranslation } from "react-i18next";
import {
  AutocompleteComponent,
  CustomAutocomplete,
  ReskinningAutocomplete,
} from "../../../../../Components";
import { useLayoutDetection } from "../../../../../Hooks";

const useFetchVendorServices = (vendorId) => {
  const { t } = useTranslation();
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getVendorServices = async () => {
      if (!vendorId) return;
      setIsLoading(true);
      try {
        const { result } = await GetAllVendorServices(vendorId, {
          pageSize: 100,
          pageIndex: 1,
        });
        setServices(result);
      } catch (error) {
        showError(t("something_went_wrong"));
      } finally {
        setIsLoading(false);
      }
    };
    getVendorServices();
  }, [vendorId, t]);

  return { services, isLoading };
};

const VendorServicesAutoComplete = ({
  vendorId,
  disabled = false,
  onChange,
  error,
  helperText,
  isWithError,
  isSubmitted,
  isAfterSales,
  ...props
}) => {
  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const isNewLayout = isReskinningLayout && hasNewLayout;

  const { categories, isLoading: isLoadingCategories } =
    useFetchVendorCategories(vendorId);
  const { services, isLoading: isLoadingServices } =
    useFetchVendorServices(vendorId);
  const data = isAfterSales ? services : categories;
  const isLoading = isAfterSales ? isLoadingServices : isLoadingCategories;

  const getOptionSelected = isAfterSales
    ? (option, value) => option.vendorServiceId === value.vendorServiceId
    : (option, value) => option.serviceCategoryId === value.serviceCategoryId;
  const displayLabel = isAfterSales
    ? (option) => option?.serviceType || ""
    : (option) => option?.serviceCategoryName || "";
  const chipsLabel = displayLabel;

  return !isNewLayout ? (
    <AutocompleteComponent
      data={data}
      getOptionSelected={getOptionSelected}
      isLoading={isLoading}
      isSubmitted={isSubmitted}
      isDisabled={disabled || isLoading}
      labelClasses="Requierd-Color"
      displayLabel={displayLabel}
      chipsLabel={chipsLabel}
      withoutSearchButton
      multiple={false}
      onChange={(_e, newValue) => {
        onChange(newValue);
      }}
      isWithError={isWithError}
      error={error}
      helperText={helperText}
      {...props}
    />
  ) : (
    <ReskinningAutocomplete
      data={data}
      getOptionSelected={getOptionSelected}
      isLoading={isLoading}
      isSubmitted={isSubmitted}
      isDisabled={disabled || isLoading}
      labelClasses="Requierd-Color"
      displayLabel={displayLabel}
      chipsLabel={chipsLabel}
      withoutSearchButton
      multiple={false}
      onChange={(_e, newValue) => {
        onChange(newValue);
      }}
      isWithError={isWithError}
      error={error}
      helperText={helperText}
      {...props}
    />
  );
};
export default VendorServicesAutoComplete;
